<template>
    <div>
        <div v-if="error" class="error__message">{{ message }}</div>
        <textarea v-bind="$attrs" class="input" :class="invalid"
                  :type="type" :placeholder="placeholder"
                  maxlength="800" v-on="$listeners"
        ></textarea>
    </div>
</template>

<script>
export default {
  name: 'TextAreaBase',
  props: {
    error: {
      type: Boolean,
    },
    message: {
      type: String,
    },
    type: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
  computed: {
    invalid() {
      return this.error ? 'form__error' : '';
    },
  },
};
</script>
